"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mapLayoutSizeToRem = function (size) {
    switch (size) {
        case 0:
        case "none":
            return "0";
        case 1:
            return "0.25rem";
        case 2:
            return "0.5rem";
        case 3:
            return "1rem";
        case 4:
            return "1.5rem";
        case 5:
            return "3rem";
        case 6:
            return "4rem";
        case "auto":
            return "auto";
        default:
            return "";
    }
};
exports.default = mapLayoutSizeToRem;
//# sourceMappingURL=index.js.map